import { helpers } from '@vuelidate/validators';
import libphonenumber from 'google-libphonenumber';
const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();

const phoneNumber = (prefix?) =>
  helpers.withParams(
    { type: 'phoneNumber', value: prefix },
    (value: any) => {
    let result = false;
    if (value) {
      try {
        value = value.replace(/\s/g,'')
        if (prefix) {
          const fullNumber = (prefix.value + value);
          const parsed = phoneUtil.parse(fullNumber, prefix.country);
          result = phoneUtil.isValidNumberForRegion(parsed, prefix.country);
          if(result){
             const parsedNationalNumber = parsed.getNationalNumber();
             result = parsedNationalNumber && value === parsedNationalNumber.toString();
          }
        } else {
          const parsed = phoneUtil.parseAndKeepRawInput(value);
          result = phoneUtil.isValidNumber(parsed);
          if(result)
          {
            result = value === phoneUtil.format(parsed, libphonenumber.PhoneNumberFormat.INTERNATIONAL).replace(/\s/g,'');
          }
        }
      } catch {
        result = false;
      }
    }
    return !helpers.req(value) || result;
    }
  );

export default phoneNumber;
